import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../../utils/Functions';

const WindowModel = ({ windowWidth, windowHeight, doorColor, glassTexture }) => {
    const railThickness = 0.01;
    const railDistance = windowWidth / 4;

    const railModel = useMemo(() => {
        let model = [];

        const rail_mid = new THREE.Shape();
        rail_mid.moveTo(-railThickness / 2, -windowHeight / 2);
        rail_mid.lineTo(-railThickness / 2, windowHeight / 2);
        rail_mid.lineTo(railThickness / 2, windowHeight / 2);
        rail_mid.lineTo(railThickness / 2, -windowHeight / 2);
        rail_mid.closePath();
        
        const rail_left = new THREE.Shape();
        rail_left.moveTo(-railDistance - railThickness / 2, -windowHeight / 2);
        rail_left.lineTo(-railDistance - railThickness / 2, windowHeight / 2);
        rail_left.lineTo(-railDistance + railThickness / 2, windowHeight / 2);
        rail_left.lineTo(-railDistance + railThickness / 2, -windowHeight / 2);
        rail_left.closePath();

        const rail_right = new THREE.Shape();
        rail_right.moveTo(railDistance - railThickness / 2, -windowHeight / 2);
        rail_right.lineTo(railDistance - railThickness / 2, windowHeight / 2);
        rail_right.lineTo(railDistance + railThickness / 2, windowHeight / 2);
        rail_right.lineTo(railDistance + railThickness / 2, -windowHeight / 2);
        rail_right.closePath();

        model.push(rail_mid)
        model.push(rail_left)
        model.push(rail_right)

        return model;
    }, [railDistance, windowHeight])

    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, -windowHeight / 2);
        model.lineTo(-windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, -windowHeight / 2);
        model.closePath();

        return model;
    }, [windowHeight, windowWidth])
    
    return (
        <>
            <mesh name='glass-rail' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[railModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} />
            </mesh>
            <mesh name='glass' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[glassModel, extrudeSettings(0.2)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
            </mesh>
        </>
    )
}

export default WindowModel